// Flash controller for auto-dismissing notifications
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['message']

  connect() {
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  dismiss() {
    this.element.classList.add('opacity-0', 'translate-x-full')
    
    // Remove from DOM after transition completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
